export default function usePathname() {
  return global.__AT_DATA__.pathname;
}
